// extracted by mini-css-extract-plugin
export default {"formText":"customAvatarList_formText__hblKr","CustomSearchBar":"customAvatarList_CustomSearchBar__4RNBg","searchIcon":"customAvatarList_searchIcon__EuxRt"};